import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';

import Dialog, { DialogProps } from '@mui/material/Dialog';

export function PageViewerToolBarContent() {
	const sx = {
		backgroundColor: '#00eeee',
		display: 'flex',
		height: 45,
		width: '50%',
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 2,
		// backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 2,
		// backgroundColor: 'yellow',
	};


	return (
		<Box sx={sx}>

				<Typography>Spaces</Typography>
				<Typography>Pages</Typography>
				<Typography>And others</Typography>
			<Box sx={sxleft}>
			</Box>
			<Box sx={sxright}>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
				>
					Edit Page
				</Button>
			</Box>
		</Box>
	)
}
